import PageContainer from 'components/common/PageContainer/PageContainer';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { excellenceAppsConfig } from 'components/Dashboards/ExcellenceApps/excellenceAppsConfig';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { RecommendationsTable } from 'components/widgets/Recommendations/recommendationsTable';

export const RecommendationsPage = () => {
    useFullStoryPageView({ pageName: excellenceAppsConfig.kcRecommendations.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader pageTitle={excellenceAppsConfig.kcRecommendations.title} />
                        <VersionCompareSelectorWrapper allowSingleVersion={true} isBaselineSelected={true} />
                    </VersionSection>
                </VersionWrapper>
            </HeaderWrapper>
            <MainContent>
                <PageWidgetWrapper>
                    <RecommendationsTable />
                </PageWidgetWrapper>
            </MainContent>

            <MainCardRoutingModal queryKeys={['recomendationTableData']} />
        </PageContainer>
    );
};
